import styled from 'styled-components'
import { TextAnnotation } from '../Annotations'

const annoTypes = {
  text: TextAnnotation,
}
export const AnnotatedImage = ({
  img,
  annotations,
  show = true,
  title,
  solo = true,
}: {
  img: string
  annotations?: Annotation[]
  show?: boolean
  solo?: boolean
  title?: string
}) => {
  return (
    <AnnotatedImageRoot
      style={{ opacity: show ? 1 : 0, position: solo ? 'unset' : 'absolute' }}
    >
      <Title>{title}</Title>
      <Image src={img} />
      <AnnotationContainer >
        {annotations?.map((annotation, i) => {
          let Annotation = annoTypes[annotation.type]
          return (
            <Annotation
              key={i}
              pos={annotation.pos}
              offset={annotation.offset}
              content={annotation.content}
              width={annotation.width}
              align={annotation.align}
            />
          )
        })}
      </AnnotationContainer>
    </AnnotatedImageRoot>
  )
}
const Title = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  text-align: center;
  font-weight: 700;
  letter-spacing: 0.4px;
  font-size: 22px;
  line-height: 1.3em;
  max-width: 500px;
  @media (max-width: 711px) {
  max-width: 80%;
    font-size: 18px;

  }
`
const AnnotatedImageRoot = styled.div.attrs({ className: 'AnnotatedImage' })`
  /* position: absolute; */
  background-color: var(--site-background);
  /* height: 100%; */
  overflow: visible;
  width: 100%;
  img {
    max-width: 100%;
  }

  @media (max-width: 711px) {
    width: 100%;
    img {
      max-width: 100%;
  
    }
  }
`

const Image = styled.img``

const AnnotationContainer = styled.div.attrs({className: 'AnnotationContainer'})`
  position: absolute;
  
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`
